import * as React from "react";
import { Button, Popover } from "@/components/ui";

type ColumnFilterShellProps = {
  title: string;
  children: React.ReactNode;
  onClear?: () => void;
};

export function ColumnFilterShell({ title, children, onClear }: ColumnFilterShellProps) {
  return (
    <Popover.Content
      className="w-80 max-w-[calc(100vw-2rem)] shadow-xl border border-slate-100 bg-white rounded-xl focus:outline-hidden overflow-hidden"
      align="start"
      side="bottom"
      sideOffset={6}
      initialFocus={false}
    >
      <div className="flex min-w-0 flex-col gap-3 overflow-hidden p-1 [&>*]:min-w-0">
        <div className="flex items-center justify-between gap-2 min-h-8">
          <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">{title}</label>
          {onClear ? (
            <Button variant="ghost" size="sm" className="h-7 shrink-0 px-2 text-xs" onClick={onClear}>
              Clear
            </Button>
          ) : null}
        </div>
        {children}
      </div>
    </Popover.Content>
  );
}
